import React from "react";
import { useTranslation } from "react-i18next";
import {
  FaNewspaper,
  FaHospital,
  FaMedkit,
  FaShieldAlt,
  FaFileMedical,
  FaHeadset,
  FaUserMd,
  FaCalendarAlt,
  FaShoppingCart,
  FaUserInjured
} from "react-icons/fa";
import "./EsmInnovation.scss";

const EsmInnovation = () => {
  const { t } = useTranslation();

  const items = [
    { id: 1, key: "info_medical", icon: <FaNewspaper />, angle: -90, labelClass: "label-top" },
    { id: 2, key: "health_management", icon: <FaHospital />, angle: -50, labelClass: "label-top-right" },
    { id: 3, key: "preventive_care", icon: <FaMedkit />, angle: -10, labelClass: "label-right" },
    { id: 4, key: "insurance", icon: <FaShieldAlt />, angle: 30, labelClass: "label-bottom-right" },
    { id: 5, key: "emr", icon: <FaFileMedical />, angle: 70, labelClass: "label-bottom" },
    { id: 6, key: "telehealth", icon: <FaHeadset />, angle: 110, labelClass: "label-bottom" },
    { id: 7, key: "home_doctor", icon: <FaUserMd />, angle: 150, labelClass: "label-bottom-left" },
    { id: 8, key: "online_booking", icon: <FaCalendarAlt />, angle: 190, labelClass: "label-left" },
    { id: 9, key: "info_product", icon: <FaShoppingCart />, angle: 230, labelClass: "label-top-left" }
  ];

  // The ring is 70% width of the container. Radius is 35%.
  const R = 35;

  return (
    <div className="innov-container">
      <h2 className="innov-title">{t("esm_implementation.item_creativity").replace(/\n/g, ' ')}</h2>
      
      <div className="innov-canvas">
        <div className="innov-ring"></div>
        
        <div className="innov-center-node">
          <div className="center-icon">
            <FaUserInjured />
          </div>
          <div className="center-text">{t("esm_implementation.patient")}</div>
        </div>

        {items.map((item) => {
          const rad = (item.angle * Math.PI) / 180;
          const left = 50 + R * Math.cos(rad);
          const top = 50 + R * Math.sin(rad);

          return (
            <div 
              key={item.id} 
              className={`innov-node ${item.labelClass}`} 
              style={{ left: `${left}%`, top: `${top}%` }}
            >
              <div className="node-circle">
                {item.icon}
              </div>
              <div className="node-label">
                {t(`esm_implementation.${item.key}`).split('\n').map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EsmInnovation;
